import React, { useState, useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import NavbarMob from "./NavbarMob";
import Navbar from "./Navbar";
import Footer from "./Footer";
import logo from "../images/login/logo.png";
import Navbar2 from "./Navbar2";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import Navbar2Mob from "./Navbar2Mob";

function Login() {
    const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
    const navigate = useNavigate();
    const [mobileNumber, setMobileNumber] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const customerType = sessionStorage.getItem("customerType");

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleLogin = async (e) => {
        if (e) e.preventDefault();

        // Step 1: Extract only digits
        const digitsOnly = mobileNumber.replace(/\D/g, ""); // e.g., "919876543210" or "09876543210"

        let finalMobile;

        if (digitsOnly.length === 12 && digitsOnly.startsWith("91")) {
            // Case: +91 9876543210 → 919876543210 → remove 91 → 9876543210
            finalMobile = digitsOnly.slice(2);
        } else if (digitsOnly.length === 11 && digitsOnly.startsWith("0")) {
            // Case: 09876543210 → remove leading 0 → 9876543210
            finalMobile = digitsOnly.slice(1);
        } else if (digitsOnly.length === 10) {
            // Clean 10-digit number
            finalMobile = digitsOnly;
        } else {
            setErrorMessage("Please enter a valid 10-digit Indian mobile number.");
            return;
        }

        // Final validation
        if (!/^\d{10}$/.test(finalMobile)) {
            setErrorMessage("Invalid mobile number format.");
            return;
        }

        try {
            // Check blocked numbers using cleaned 10-digit number
            const blockedProfilesResponse = await fetch(`${apiBaseUrl}/getBlockedProfiles`);
            const blockedProfiles = await blockedProfilesResponse.json();

            const isBlocked = blockedProfiles.some(
                (profile) =>
                    (profile.ProfileType === "employee" || profile.ProfileType === "candidate") &&
                    profile.MobileNumber === finalMobile
            );

            if (isBlocked) {
                alert("This mobile number is blocked.");
                return;
            }

            // Try employee login
            const response = await fetch(`${apiBaseUrl}/login`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ mobileNumber: finalMobile, password }),
            });

            const data = await response.json();

            if (response.ok && data.success) {
                storeEmployeeData(data);
                navigate("/home");
            } else {
                const candidateSuccess = await attemptCandidateLogin(finalMobile);
                if (!candidateSuccess) {
                    await attemptStaffLogin(finalMobile);
                }
            }
        } catch (error) {
            console.error("Login error:", error);
            setErrorMessage("Network error. Please try again.");
        }
    };

    // Update attemptCandidateLogin to accept cleaned mobile
    const attemptCandidateLogin = async (cleanedMobile) => {
        try {
            const response = await fetch(`${apiBaseUrl}/loginCandidate`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ mobile: cleanedMobile, password }),
            });

            const data = await response.json();

            if (response.ok && data.success) {
                storeCandidateData(data);
                navigate("/home");
                return true;
            } else {
                setErrorMessage(data.message || "Candidate login failed.");
                return false;
            }
        } catch (error) {
            console.error("Candidate login error:", error);
            setErrorMessage("An error occurred during candidate login.");
            return false;
        }
    };

    // Update attemptStaffLogin too
    const attemptStaffLogin = async (cleanedMobile) => {
        try {
            const response = await fetch(`${apiBaseUrl}/loginstaff`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ mobileNumber: cleanedMobile, password }),
            });

            const data = await response.json();

            if (response.ok && data.success) {
                storeStaffData(data);
                navigate("/home");
            } else {
                setErrorMessage(data.message || "Login failed. Please check your credentials.");
            }
        } catch (error) {
            console.error("Staff login error:", error);
            setErrorMessage("An error occurred during staff login.");
        }
    };

    const storeEmployeeData = (data) => {
        sessionStorage.setItem("employeeId", data.employeeId);
        sessionStorage.setItem("customerName", data.customerName);
        sessionStorage.setItem("customerType", data.customerType);
        sessionStorage.setItem("address", data.address);
    };

    const storeCandidateData = (data) => {
        sessionStorage.setItem("employeeId", data.candidate.CandidateID);
        sessionStorage.setItem("customerName", data.candidate.Name);
        sessionStorage.setItem("houseName", data.candidate.houseName);
        sessionStorage.setItem("experienced", data.candidate.experienced);
        sessionStorage.setItem("customerType", data.candidate.customerType);
        sessionStorage.setItem("preferredJob", data.candidate.Jobs);
        sessionStorage.setItem("preferredLocation", data.candidate.Locations);
        sessionStorage.setItem("jobType", data.candidate.JobType);
        sessionStorage.setItem("District", data.candidate.District);
        sessionStorage.setItem("gender", data.candidate.Gender);
        sessionStorage.setItem("Email", data.candidate.Email);
        sessionStorage.setItem("mobileNumber", data.candidate.Mobile);
        sessionStorage.setItem("whatsappNumber", data.candidate.WhatsApp);
        sessionStorage.setItem("selectedPlan", data.candidate.SelectedPlan);
    };

    const storeStaffData = (data) => {
        sessionStorage.setItem("customerType", data.candidate.customerType);
        sessionStorage.setItem("customerName", data.candidate.companyName);
        sessionStorage.setItem("employeeId", data.candidate.staffId);
        sessionStorage.setItem("address", data.candidate.address);
        sessionStorage.setItem("power", data.candidate.power);
        sessionStorage.setItem("specialPower", data.candidate.specialPower);
        sessionStorage.setItem("enablePackage", data.candidate.enablePackage);
        sessionStorage.setItem("locationPower", data.candidate.locationPower || "off");
        sessionStorage.setItem("hiddenLocations", data.candidate.hiddenLocations || "");
    };

    const regchoose = () => {
        navigate("/regchoose");
    };

    return (
        <div className="flex flex-col min-h-screen">
            {isMobile ? <NavbarMob /> : <Navbar />}
            <div className="md:flex hidden">
                <Navbar2 />
            </div>
            <div className="md:hidden flex flex-col">
                <Navbar2Mob />
            </div>
            <div className="flex justify-center items-center bg-[black] py-7">
                <div className="lg:w-[30%] w-[90%] h-[70%] bg-[white] flex flex-col items-center px-2 gap-6 py-6 lg:rounded-[20px] rounded-[5px]">
                    <div className="flex flex-col justify-center items-center gap-3">
                        <span className="text-2xl font-[600] font-display">Login</span>
                        <span className="text-base font-[400] font-display">
                            Log In to Continue Your Job Search Journey
                        </span>
                    </div>

                    {errorMessage && <div className="text-red-500">{errorMessage}</div>}

                    <form onSubmit={handleLogin} className="w-full h-auto gap-3 flex flex-col mt-5">
                        <div className="h-[56px] w-full lg:px-12 px-2">
                            <input
                                type="text"
                                className="border-2 border-[#000000] w-full h-full rounded-[12px] px-3"
                                placeholder="Enter your Mobile Number"
                                value={mobileNumber}
                                onChange={(e) => {
                                    // Allow: digits, +, spaces, dashes, parentheses
                                    const value = e.target.value;
                                    if (/^[\d+\-\s()]*$/.test(value)) {
                                        setMobileNumber(value);
                                    }
                                }}
                                maxLength="18"
                            />
                        </div>

                        <div className="h-[56px] w-full lg:px-12 px-2 relative flex flex-row">
                            <input
                                type={showPassword ? "text" : "password"}
                                className="border-2 border-r-0 border-[#000000] w-[80%] h-full rounded-l-[12px] px-3 focus:outline-none focus:ring-0"
                                placeholder="Enter your password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                            <div
                                className="w-[20%] h-full cursor-pointer flex justify-center items-center border-l-0 border-[#000000] border-2 rounded-r-[12px]"
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                {showPassword ? <FaEyeSlash size={20} /> : <FaEye size={20} />}
                            </div>
                        </div>

                        <div className="h-[56px] w-full px-12">
                            <button
                                type="submit"
                                className="w-full h-full bg-[#E22E37] rounded-[28px] flex justify-center items-center text-[white] text-base font-[600] font-display hover:bg-[red] focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                            >
                                SUBMIT
                            </button>
                        </div>
                    </form>

                    {!customerType && (
                        <>
                            <span className="text-base font-[400] font-display text-[#8B8B8B]">or</span>
                            <span>
                                <span className="font-[400] text-base font-display text-[#8B8B8B]">Not a Member?</span>
                                <span
                                    className="font-[400] text-base font-display text-[#E22E37] cursor-pointer hover:text-[black]"
                                    onClick={regchoose}
                                >
                                    {" "}
                                    Free Register Here
                                </span>
                            </span>
                        </>
                    )}

                    <img src={logo} alt="logo" />
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default Login;
